import { useFlags } from 'flagsmith/react';
import { get } from 'lodash';

export const useFeatureFlag = (feature: string) => {
    const flags = useFlags([feature]);
    return get(flags, `${feature}.enabled`, false);
};
